import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionTypeSettingsComponent } from '../../models/question-type-settings-component.constants';

@Component({
  selector: 'empathy-question-settings',
  templateUrl: 'question-settings.component.html',
  styleUrls: ['./question-settings.component.scss', './_question-settings-theme.component.scss']
})
export class QuestionSettingsComponent {
  @Input() activeQuestion: FormGroup;

  questionTypeSettingsComponent = QuestionTypeSettingsComponent;
}
